/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineDocumentsRequest
 */
export interface CombineDocumentsRequest {
    /**
     * The lead ID to retain (documents will be added here)
     */
    retain_lead_id: string;
    /**
     * Lead IDs to combine (copy docs from, then cancel)
     */
    combine_lead_ids: Array<string>;
    /**
     * Facility ID
     */
    facility_id: string;
    /**
     * Document IDs to exclude from copying
     */
    exclude_document_ids?: Array<string>;
}

/**
 * Check if a given object implements the CombineDocumentsRequest interface.
 */
export function instanceOfCombineDocumentsRequest(value: object): value is CombineDocumentsRequest {
    if (!('retain_lead_id' in value) || value['retain_lead_id'] === undefined) return false;
    if (!('combine_lead_ids' in value) || value['combine_lead_ids'] === undefined) return false;
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    return true;
}

export function CombineDocumentsRequestFromJSON(json: any): CombineDocumentsRequest {
    return CombineDocumentsRequestFromJSONTyped(json, false);
}

export function CombineDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'retain_lead_id': json['retain_lead_id'],
        'combine_lead_ids': json['combine_lead_ids'],
        'facility_id': json['facility_id'],
        'exclude_document_ids': json['exclude_document_ids'] == null ? undefined : json['exclude_document_ids'],
    };
}

export function CombineDocumentsRequestToJSON(json: any): CombineDocumentsRequest {
    return CombineDocumentsRequestToJSONTyped(json, false);
}

export function CombineDocumentsRequestToJSONTyped(value?: CombineDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'retain_lead_id': value['retain_lead_id'],
        'combine_lead_ids': value['combine_lead_ids'],
        'facility_id': value['facility_id'],
        'exclude_document_ids': value['exclude_document_ids'],
    };
}

